import { GameAvailableWinDisplayProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameAvailableWinDisplayProperties";
/**
 * AvailableWinDisplayLandscapeProperties.ts
 */
export class AvailableWinDisplayLandscapeProperties extends GameAvailableWinDisplayProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.availableWinTextHolderPosition.set(973, 430);
        this.availableWinTextHolderScale.set(0.73);
    }
}
//# sourceMappingURL=AvailableWinDisplayLandscapeProperties.js.map